import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { mapProps, compose, branch, renderNothing } from 'recompose'
import CSSModules from 'helpers/CSSModulesUtil'
import FontIcon from 'react-toolbox/lib/font_icon'

import hideOnAnyRoles from 'containers/Role/Hide/AnyGlobalRoles'
import { GLOBAL_ROLES } from 'containers/Role/constants'

import styles from './styles.scss'

const Icon = compose(
  mapProps((props) => ({
    ...props,
    roles: [ GLOBAL_ROLES.CLIENT_ACCESS ]
  })),
  hideOnAnyRoles,
)(FontIcon)

const CheckIcon = () => <Icon class={styles.internalIcon} value='check'/>

const withStyle = CSSModules(styles)
const InternalIcon = compose(
  branch(
    ({ internal }) => !internal,
    renderNothing
  )
)(CheckIcon)

export default withStyle(InternalIcon)
